import React from 'react'
import PropTypes from 'prop-types'
import Filters from './Filters'
import css from './search-filters.css'
import styles from './styles.css'

const SearchFilters = ({
  allLocationsChecked,
  doctors,
  fetchNewPatientList,
  handleSearchChange,
  hasDSO,
  locations,
  patientsWithApptsInTimeRange,
  patientStatuses,
  searchValue,
  selectAppointmentDoctor,
  selectAppointmentLocation,
  selectATypesAndPStatuses,
  selectedAppointmentTypeIds,
  selectedPatientStatusIds,
  selectedDoctorId,
  selectedLocationId,
  toggleAllLocations,
}) => (
  <div className={css.wrapper}>
    <div className={css.filterTitleContainer}>
      <div className={styles.filtersTitle}>Filters:</div>
    </div>
    <Filters
      allLocationsChecked={allLocationsChecked}
      doctors={doctors}
      handleSearchChange={handleSearchChange}
      hasDSO={hasDSO}
      fetchNewPatientList={fetchNewPatientList}
      patientsWithApptsInTimeRange={patientsWithApptsInTimeRange}
      locations={locations}
      patientStatuses={patientStatuses}
      searchValue={searchValue}
      selectAppointmentDoctor={selectAppointmentDoctor}
      selectAppointmentLocation={selectAppointmentLocation}
      selectATypesAndPStatuses={selectATypesAndPStatuses}
      selectedAppointmentTypeIds={selectedAppointmentTypeIds}
      selectedPatientStatusIds={selectedPatientStatusIds}
      selectedDoctorId={selectedDoctorId}
      selectedLocationId={selectedLocationId}
      toggleAllLocations={toggleAllLocations}
    />
  </div>
)

SearchFilters.propTypes = {
  allLocationsChecked: PropTypes.bool.isRequired,
  doctors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      preferred_name: PropTypes.string,
    }),
  ),
  fetchNewPatientList: PropTypes.func,
  handleSearchChange: PropTypes.func,
  hasDSO: PropTypes.bool.isRequired,
  patientsWithApptsInTimeRange: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  patientStatuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  searchValue: PropTypes.string,
  selectAppointmentDoctor: PropTypes.func,
  selectAppointmentLocation: PropTypes.func,
  selectATypesAndPStatuses: PropTypes.func,
  selectedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPatientStatusIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedDoctorId: PropTypes.string,
  selectedLocationId: PropTypes.string,
  toggleAllLocations: PropTypes.func,
}

export default SearchFilters



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/SearchFilters.js